import React from "react";
import { IconsProps } from "./dto";

export function ReceivedIcon(props: IconsProps) {
    return (
        <svg width={props.size} height={props.size} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.5 3.5L3.5 8.5M3.5 8.5H8.5M3.5 8.5V3.5" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}